module.exports = __webpack_public_path__ + "static/media/your-ratings-their-ratings.584fdb9b.png";